import React from "react";

const defaultElementsConsideredEC = [
  {
    elementLabelEC: "Physical risks (e.g., flooding, droughts)",
    yesNoEC: "",
    explanationEC: "",
  },
  {
    elementLabelEC: "Transitional risks (e.g., policy changes, carbon tax)",
    yesNoEC: "",
    explanationEC: "",
  },
  {
    elementLabelEC: "Climate-related opportunities (e.g., green products)",
    yesNoEC: "",
    explanationEC: "",
  },
  {
    elementLabelEC: "Regional / local variables (e.g., infrastructure)",
    yesNoEC: "",
    explanationEC: "",
  },
  {
    elementLabelEC: "Policy and macroeconomic trends",
    yesNoEC: "",
    explanationEC: "",
  },
  {
    elementLabelEC: "Energy mix assumptions",
    yesNoEC: "",
    explanationEC: "",
  },
  {
    elementLabelEC: "Technological changes",
    yesNoEC: "",
    explanationEC: "",
  },
];

const ElementsConsideredTable = ({
  elementsConsideredEC,
  setElementsConsideredEC,
}) => {
  const handleChange = (index, field, value) => {
    const updated = [...elementsConsideredEC];
    updated[index][field] = value;
    setElementsConsideredEC(updated);
  };

  // no per-cell borders here (inner grid draws them)
  const cell = {
    padding: "15px",
    textAlign: "left",
    verticalAlign: "top",
  };

  const header = {
    ...cell,
    backgroundColor: "#d3c9ce",
    fontWeight: "bold",
    textAlign: "center",
  };

  const leftLabelCell = {
    ...cell,
    backgroundColor: "#d3c9ce",
    fontWeight: 600,
  };

  const inputStyle = {
    width: "100%",
    padding: "10px 12px",
    border: "1px solid gray",
    borderRadius: "6px",
    fontSize: "14px",
  };

  return (
    <div
      style={{
        overflowX: "auto",
        marginTop: 20,
        borderRadius: 12,
        overflow: "hidden",
        border: "1px solid #000", // outer frame
      }}
    >
      {/* Inner grid + hide outer edges so corners align perfectly */}
      <style>{`
        .ecTable{
          width: 100%;
          border-collapse: collapse;
        }
        .ecTable th,
        .ecTable td{
          border: 1px solid #000;
          padding: 15px;
          vertical-align: top;
          text-align: left;
        }
        .ecTable thead th{
          background: #d3c9ce;
          font-weight: 700;
          text-align: center;
        }
        /* hide outer edges (the frame above draws them) */
        .ecTable thead tr:first-child th{ border-top: 0; }
        .ecTable tr th:first-child,
        .ecTable tr td:first-child{ border-left: 0; }
        .ecTable tr th:last-child,
        .ecTable tr td:last-child{ border-right: 0; }
        .ecTable tbody tr:last-child td{ border-bottom: 0; }
      `}</style>

      <table className="ecTable">
        <thead>
          <tr>
            <th style={header}>Elements considered</th>
            <th style={header}>Yes / No</th>
            <th style={header}>If yes, briefly explain</th>
          </tr>
        </thead>

        <tbody>
          {elementsConsideredEC.map((row, idx) => (
            <tr key={idx}>
              <td style={leftLabelCell}>{row.elementLabelEC}</td>
              <td style={cell}>
                <input
                  style={inputStyle}
                  placeholder="Enter data"
                  value={row.yesNoEC}
                  onChange={(e) => handleChange(idx, "yesNoEC", e.target.value)}
                />
              </td>
              <td style={cell}>
                <input
                  style={inputStyle}
                  placeholder="Enter data"
                  value={row.explanationEC}
                  onChange={(e) =>
                    handleChange(idx, "explanationEC", e.target.value)
                  }
                />
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default ElementsConsideredTable;
